// apps/vendor/src/features/support/supportRealtime.ts
//
// dbg-20260705-ticket-realtime-notify — vendor unread count across BOTH support
// surfaces (vendor-raised `vendor_support_tickets` + admin-assigned `tickets`).
// Feeds the VendorSidebar Support badge; shares the list query caches so no
// extra fetch beyond what the Support page already triggers.

import { useTicketsList, useAssignedList } from './api.js';

export function useVendorSupportUnread(): number {
  // Plan 5: vendor-raised tickets moved to the unified /vendor/tickets payload,
  // which is PII-stripped and carries no per-staff `unread` flag — so the mine
  // side no longer contributes to the badge (only admin-assigned tickets do).
  // Query kept to warm the shared list cache the Support page also uses.
  useTicketsList({ pageSize: 100 });
  const assigned = useAssignedList();
  const assignedUnread = (assigned.data?.rows ?? []).filter(
    (r) => r.unread === true,
  ).length;
  return assignedUnread;
}
